<template>

  <div>

    <a-scene>
      <a-assets>
        <!--<img id="history-1" src="../assets/1.png">-->
        <a-box id="rail"
               static-body color="red"
               depth="1" width="100" height="1"></a-box>
      </a-assets>

      <a-entity camera position="0 6 0" rotation="-35 0 0" look-controls wasd-controls="acceleration: 100; easing: 5">
        <a-animation attribute="position" dur="120000" easing="linear" to="0 5 -400"></a-animation>
      </a-entity>

      <!--<a-entity environment="preset: arches; "></a-entity>-->
      <a-sky color="black"></a-sky>
      <a-entity star-system="count: 10000; radius: 250; depth: 0"></a-entity>

      <!--<a-plane v-for="(m, index) in moments" :key="index"-->
               <!--:id="m.src" :src="m.src" :height="m.height" :width="m.width"-->
               <!--:rotation="rotation(m.rotation)" position="-.3 -1 -10"></a-plane>-->

      <a-entity v-for="m in moments" track-by="$index"
                :geometry="m.geometry"
                :material="m.material"
                :rotation="coordToString(m.rotation)"
                :position="coordToString(m.position)"
      ></a-entity>

      <a-text v-for="m in moments" track-by="$index"
              align="center"
              :text="m.textValue"
              :color="m.textColor"
              :geometry="m.textGeometry"
              :material="m.textMaterial"
              :rotation="coordToString(m.textRotation)"
              :position="coordToString(m.textPosition)"
              :scale="m.textScale"
      ></a-text>


    </a-scene>

  </div>



</template>

<script>

const DEFAULT_HEIGHT = 13;
const DEFAULT_WIDTH = 13;
const DEFAULT_ROTATION = { x: -90, y: 1, z: 0 };
const DEFAULT_POSITION = { x: -0.3, y: 1, z: -10 };

class Moment {
  constructor(src, text, posZ) {
    this.src = src;
    this.height = DEFAULT_HEIGHT;
    this.width = DEFAULT_WIDTH;
    this.rotation = DEFAULT_ROTATION;
    this.position = { x: DEFAULT_POSITION.x, y: DEFAULT_POSITION.y, z: posZ };
    this.material = `color: #ccc; src: ${src};`;
    this.geometry = `primitive: plane; height: ${DEFAULT_HEIGHT}; width: ${DEFAULT_WIDTH};`;
    // this.geometry = `primitive: box; height: ${DEFAULT_HEIGHT}; width: ${DEFAULT_WIDTH}; depth: 0.1`;

    this.text = text;
    this.textValue = `value: ${text};`;
    this.textColor = '#055616';
    this.textRotation = DEFAULT_ROTATION;
    this.textPosition = { x: DEFAULT_POSITION.x, y: DEFAULT_POSITION.y, z: ( posZ + 8 ) };
    this.textMaterial = 'color: #fff; transparent: true; opacity: 0';
    this.textGeometry = 'primitive: plane; height: 5; width: 5;';
    this.textScale = '10 10 1';
  }
}

export default {
  name: 'TimeMachine',
  data() {
    return {
      moments: [
        new Moment('static/history-1.png', '1993', -15),
        new Moment('static/history-2.png', '1996', -35),
        new Moment('static/history-3.png', '1999', -55),
        new Moment('static/history-4.png', '1999', -75),
        new Moment('static/history-5.png', '2000', -95),
        new Moment('static/history-6.png', '2001', -115),
        new Moment('static/history-7.png', '2002', -135),
        new Moment('static/history-8.png', '2006', -155),
        new Moment('static/history-9.png', '2008', -175),
        new Moment('static/history-10.png', '2010', -195),
        new Moment('static/history-11.png', '2011', -205),
        new Moment('static/history-12.png', '2012', -225),
        new Moment('static/history-13.png', '2013', -245),
        new Moment('static/history-14.png', '2014', -265),
        new Moment('static/history-15.png', '2015', -285),
        new Moment('static/history-16.png', '2016', -305),
        new Moment('static/history-17.png', '2017', -325),
        new Moment('static/history-18.png', 'Today', -345),
      ],
    };
  },
  methods: {
    coordToString(coord) {
      return `${coord.x} ${coord.y} ${coord.z}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/TimeMachine.vue